import PropTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import './style.scss';

// Types.
import InstanceTarget from '../../types/instance/InstanceTarget';
import HostTarget from '../../types/host/HostTarget';
import EventType from '../../types/instance/EventType';

// Admin Views.
import StatisticsWrapper from "../../container/statistics/statistics-wrapper";
import StatisticsComparison from "../../container/comparison/statistics-comparison";
import ParameterComparison from "../../container/comparison/parameter-comparison";
import ActivityComparison from "../../container/comparison/activity-comparison";

function Reports(props: {
    instances: InstanceTarget[],
    hosts: HostTarget[],
    eventTypes: EventType[],
    toggleMenu: Function,
}) {
    return (
        <>
            <Routes>

                <Route path="/activity-comparison" element={<ActivityComparison
                                                                   toggleMenu={props.toggleMenu}/>}/>

                <Route path="/sql-stats-explorer/*"
                       element={<StatisticsWrapper instance={null} type={null} hosts={props.hosts}
                                                   toggleMenu={props.toggleMenu}/>}/>
                <Route path="/sql-stats-comparison/*"
                       element={<StatisticsComparison toggleMenu={props.toggleMenu}
                                                     />}/>
                <Route path="/parameter-comparison/*"
                       element={<ParameterComparison toggleMenu={props.toggleMenu}
                                                     />}/>
            </Routes>
        </>
    );
}

Reports.propTypes = {
    toggleMenu: PropTypes.func.isRequired
};

export default Reports;
